import {getMembersByTeam, getTeamById, removeMemberFromTeam, changeTeamMemberRole, inviteTeamMemberCount, failedTeamMemberList, pendingTeamMemberList, getCollaboratorList, pendingMemberFieldFilter, failedMemberFieldFilter, memberFieldFilter, pendingCollabFieldFilter, cancelCollaboratorInvitation, cancelTeamMemberInvitation} from '@/libs/api/api'
import {message, errorHandler, logout, onError, getImageUrl, getAppliedFilters, loader, routeErrorHandler } from '@/libs/helper'
import constants from '@/libs/constant/constants'
import {cloneDeep, isEmpty} from 'lodash'
import OrgFilter from '@/components/pages/InformationPortal/Organisation/OrgFilter/OrgFilter.vue'
import pageRoute from '@/libs/constant/pageRoutes'
import SettingsDropdown from '@/components/component/Reuse/SettingsDropdown/SettingsDropdown.vue'
import { mapGetters } from 'vuex'
import OrganisationRolesErrorHandlerMixin from '@/mixins/OrganisationRolesErrorHandlerMixin'
import permissions from '@/libs/constant/permissions'

export default {
    name: 'TeamMembers',
    mixins: [OrganisationRolesErrorHandlerMixin],
    components: {
        OrgFilter,
        SettingsDropdown,
        InvitePeople: () => import('@/components/pages/InformationPortal/Organisation/InvitePeople/InvitePeople.vue')
    },
    mounted() {
        this.fetchPeopleList()
        this.getTeamData()
        this.getInviteCounts()
    },
    props: {
        updateCount: {
            type: Function,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters({
            teamRoles: 'getTeamRoles', hasPermission: 'hasPermission'
        })
    },
    data() {
        return {
            onError,
            getImageUrl,
            isInvite: false,
            selectedTableFilters: {},
            columns: ['name', 'role', 'settings'],
            peopleResult: {},
            peopleList: [],
            organisationDetails: {},
            currentPage: 1,
            skip: 0,
            limit: 30,
            sort: 'name',
            order: 'desc',
            tableSettings: {
                headings: {
                  name: 'Name',
                  settings: '',
                  role: 'Role',
                },
                perPage: 30,
                pagination: { show: false},
                filterable: [],
                filterByColumn: true,
                sortable: ['no']
            },
            isChangeRole: false,
            selectedMemberToUpdate: {},
            selectedMemberRight: '',
            selectedMenu: constants.PEOPLE_LIST.MEMBER,
            peopleCounts: {},
            searchValue: '',
            selectedSearchValue: '',
            isFetchingPeople: false,
            permissions: permissions
        }
    },
    methods: {
       /**
         * to close invite dialog
         */
        closeInviteDialog () {
            this.isInvite = false
        },

        /**
         * handle command
         */
        handleCommand (option, data) {
            switch (option) {
                case 'DELETE':
                    this.deleteMember(data)
                break
                case 'CHANGE_ROLE':
                    this.selectedMemberToUpdate = data
                    this.updateMemberRights()
                break
                case 'CANCEL_INVITATION': 
                    this.removePendingRequest(data)
                break
                case 'CANCEL_INVITATION_COLLABORATOR':
                    this.removePendingRequest(data, true)
                break
            }
        },

        /**
         * get details of current team
         */
        async getTeamData () {
            this.organisationDetails = cloneDeep(this.$store.getters.getTeam) || {}
            if (isEmpty(this.organisationDetails)) {
                let response = await getTeamById(this.$route.params.tid)
                this.organisationDetails = response || {}
                this.$store.dispatch('setTeam', response)
            }   
        },

        /**
         * to change the pages 
         * @param {*} currentPage 
         */
        changePage (currentPage) {
            this.currentPage = currentPage
            // setting the skip as per the current page
            this.skip = (currentPage - 1) * this.limit
            // fetch members list
            this.fetchPeopleList()
        },
        /**
       * to change sort 
       */
      changeOrder () {
        // change sort
        this.order = this.order === 'desc' ? 'asc' : 'desc'
        // set skip to zero
        this.skip = 0
        // fetch new teams
        this.fetchPeopleList()
      },
        /**
         * 
         * @param {*} filters 
         */
        setTableFilters (filters) {
            this.selectedTableFilters = cloneDeep(filters)
            this.$store.dispatch('setOganisationFilters', filters)
            if (this.selectedSearchValue === '') this.changePage(1)
        },

        /**
         * route to member page
         */
        routeToMember (row) {
            this.$router.push({name: `users-overview`, params: {id: row._id}})
        },
        /**
         * to remove member from team
         * @param {*} data 
         */
        async deleteMember (data) {
            const mainTitle = `${window.i18next.t(`Remove member`)} `;
            const nameTitle = `${data.first_name} ${data.last_name}`;
            // html for popup
            const html =
                `<div class="remove-body remove-people">
                    <div class="popup-title remove-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container remove-warning">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            ${window.i18next.t('When you remove a member, you can no longer make any changes to it')}.
                        </div>
                    </div>
                    <div class="warning-confirmation-text remove-warn">
                        ${window.i18next.t('Are you sure you would like to remove the member, it can not be undone')}?
                    </div>                    
                </div>`
                // confirmation box
                this.$confirm(`${html}`, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: window.i18next.t('Remove'),
                    cancelButtonText: window.i18next.t('Cancel'),
                    showClose: false,
                    closeOnClickModal: false,
                    customClass: 'remove-team-popup',
                    confirmButtonClass: 'primary-button confirm mini-button',
                    cancelButtonClass: 'primary-button mini-button'
                }).then(async() => {
                    // api all
                    loader(this, true)
                    try {
                        // body for api
                        let body = {
                            team: this.$route.params.tid,
                            member: data._id
                        }
                        // api call
                        let response = await removeMemberFromTeam(body)
                        if (response.success) {
                            this.peopleList = this.peopleList.filter(member => data._id !== member._id)
                            this.peopleResult.total_count -= 1
                            message(this, constants.messageType.SUCCESS, response.message)
                        }
                    } catch (error) {
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                        // error handler for permissions
                        this.rolesErrorHandler(error, true)
                    } finally {
                        loader(this, false)
                    }
                }).catch((error) => {
                    console.error('--', error)
                    loader(this, false)
                })
        },
        /**
         * to close the change role dialog
         */
        closeRoleDialog () {
            this.isChangeRole = false
            this.selectedMemberToUpdate = {}
            this.selectedMemberRight = ''
        },
        /**
         * to update the rights of member
         */
        async updateMemberRights () {
            try {
                loader(this, true)
            // body for api
            let body = {
                member: this.selectedMemberToUpdate._id,
                team: this.$route.params.tid
            }
            // api call
            let response = await changeTeamMemberRole(body)
            if (response.success) {
                this.peopleList = this.peopleList.map(list => {
                    if (list._id === this.selectedMemberToUpdate._id) list.role = list.role === 'Member' ? 'Lead' : 'Member'
                    this.changePage(this.currentPage)
                    return list
                })
                // if owner is changing its own rights
                if (this.$store.getters.getUserInformation.id === this.selectedMemberToUpdate._id) {
                    // update org roles and permissions
                    this.$store.dispatch('setUpdateTeamRoles', true)
                    // route to overview page
                    this.$router.push({name: pageRoute.teamOverview, params: {id: this.$route.params.id, tid: this.$route.params.tid}})
                }
                message(this, constants.messageType.SUCCESS, 'Team role changed successfully')
            }
            this.closeRoleDialog()
            } catch (error) {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            }
            loader(this, false)
        },
        /**
         * to change the menu
         * @param {*} menu 
         */
        changeMenu (menu) {
            // to clear the skip, limit and order
            this.clearFields()
            // select menu
            this.selectedMenu = menu
            // to turn on fetching 
            this.isFetchingPeople = true
            // fetch people list based on menu
            this.fetchPeopleList()
        },

        /**
         * to get the counts of invite
         */
        getInviteCounts () {
            if(!this.hasPermission(permissions.inviteCount)) return;
            // api call
            inviteTeamMemberCount({team: this.$route.params.tid}).then(response => {
                this.peopleCounts = response || {}
                let count = Object.values(response).reduce((a, b) => a+b, 0)
                this.updateCount(constants.PEOPLE_LIST.MEMBER, count)
            }).catch(error => {
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            })
        },
        /**
         * fetch people list
         */
        async fetchPeopleList () {
            try {
                if(!this.hasPermission(permissions.getMembersByTeam)) return;
                // params for api
                let params = await this.fetchParams()
                // body for api
                let body = {}
                // if search is active
                if (this.selectedSearchValue !== '') body.names = [this.selectedSearchValue]
                // if filters are applied
                else body = await getAppliedFilters(this.selectedTableFilters)
                let isUpdateCount = isEmpty(body)
                // add team in body
                body.team = this.$route.params.tid
                let response = await this.fetchPeopleListAPI(body, params)
                this.peopleResult = response || {}
                // people list
                this.peopleList = response.items || []
                // to update the count from list
                if (isUpdateCount) this.updatePeopleCount(response.total_count || 0)
            } catch (error) {
                this.peopleResult = {}
                this.peopleList =  []
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            }
            this.isFetchingPeople = false
        },

        /**
         * to fetch the people list from api
         */
        async fetchPeopleListAPI (body, params) {
            switch (this.selectedMenu) {
                case constants.PEOPLE_LIST.PENDING_INVITATION:
                    return pendingTeamMemberList(body, params)
                case constants.PEOPLE_LIST.FAILED_INVITATION:
                    return failedTeamMemberList(body, params)
                case constants.PEOPLE_LIST.PENDING_COLLABORATORS:
                    body.organisation = this.$route.params.id
                    return getCollaboratorList(body, params)
                default:
                    return getMembersByTeam(body, params)
            }
        },
        /**
         * fetch params
         */
        fetchParams () {
            let params = {
                skip: this.skip,
                limit: this.limit,
                sort: this.sort,
                order: this.order
            }
            return params
        },
        /**
         * update people count
         * @param {*} count 
         */
        updatePeopleCount (count) {
            switch (this.selectedMenu) {
                case constants.PEOPLE_LIST.PENDING_INVITATION:
                    this.peopleCounts.pending_invitations = count
                break
                case constants.PEOPLE_LIST.FAILED_INVITATION:
                    this.peopleCounts.failed_invitations = count
                break
                case constants.PEOPLE_LIST.PENDING_COLLABORATORS:
                    this.peopleCounts.pending_collaborators = count
                break
                default:
                    this.peopleCounts.members_count = count
                break
            }
            let totalCount = Object.values(this.peopleCounts).reduce((a, b) => a+b, 0)
            this.updateCount(constants.PEOPLE_LIST.MEMBER, totalCount)
        },

        /**
         * handle filters
         * @param {*} item 
         */
        handleFilters (item) {
            // to set the filters
            this.selectedSearchValue = item.data
            // to clear filters
            this.clearNameFilter = true
            this.searchValue = item.data
            this.changePage(1)
        },
        
        /**
         * query search for find people
         * @param {*} queryString 
         * @param {*} cb 
         */
        async querySearch (queryString, cb) {
            try {
                if (queryString !== '' && queryString !== null && queryString !== undefined && queryString.length > 1) {
                    let results = []
                    let body = {
                        team: this.$route.params.tid,
                        search_text: queryString,
                        field_value: 'name'
                    }
                    let response = await this.getFiltersAPI(body)
                    results = response.items || []
                    cb(results)     
                }
            } catch (error) {
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            }     
              
        },

        /**
         * 
         */
        getFiltersAPI (body) {
            switch (this.selectedMenu) {
                case constants.PEOPLE_LIST.PENDING_INVITATION:
                    return pendingMemberFieldFilter(body)
                case constants.PEOPLE_LIST.PENDING_COLLABORATORS:
                    body.organisation = this.$route.params.id
                    return pendingCollabFieldFilter(body)
                case constants.PEOPLE_LIST.MEMBER:
                    console.log('hello')
                    if(!this.hasPermission(permissions.memberFieldFilter)) return;
                    return memberFieldFilter(body)
                case constants.PEOPLE_LIST.FAILED_INVITATION:
                    return failedMemberFieldFilter(body)
            }
        },

         // to clear the fields
         clearFields () {
            this.skip = 0
            this.limit = 30
            this.sort = 'name'
            this.order = 'desc'
            this.peopleResult = {}
            this.clearNameFilter = true
            this.selectedTableFilters = {}
            this.searchValue = ''
            this.selectedSearchValue = ''
        },
        /**
         * remove Pending requests
         */
        removePendingRequest (item, isCollaborator) {
            const mainTitle = `${window.i18next.t(`Cancel invitation`)} `;
            const nameTitle = `${item.first_name} ${item.last_name}`;
            // html for popup
            const html =
                `<div class="remove-body remove-people">
                    <div class="popup-title remove-title"><span>
                    ` + mainTitle +`
                    </span>: <span class="listing-name">
                    ` + nameTitle + `
                    </span></div>
                    <div class="warning-text-container remove-warning">
                        <div class="warning-icon">
                            <i class="nova-warningalert"></i>
                        </div>
                        <div class="warning-text">
                            ${window.i18next.t('When you cancel the invitation, we will inform the Newsroom member by email')}.
                        </div>
                    </div>
                    <div class="warning-confirmation-text remove-warn">
                        ${window.i18next.t('Are you sure you would like to cancel the invitation, it can not be undone')}?
                    </div>                    
                </div>`
                // confirmation box
                this.$confirm(`${html}`, {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: window.i18next.t('Cancel invitation'),
                    cancelButtonText: window.i18next.t('Cancel'),
                    showClose: false,
                    closeOnClickModal: false,
                    customClass: 'remove-team-popup',
                    confirmButtonClass: 'primary-button confirm mini-button',
                    cancelButtonClass: 'primary-button mini-button'
                }).then(() => {
                    // if rquest is for collaborator
                    if (isCollaborator) this.removeCollaboratorInvitation(item)
                    // else for people
                    else this.cancelPeopleInvitation(item)
                })
        },
        /**
         * to cancel the collaborator invitation
         * @param {*} collaborator 
         */
        async removeCollaboratorInvitation (collaborator) {
            try {
                loader(this, true)
                // body for api
                let body = {
                    organisation: this.$route.params.id,
                    invite_id: collaborator.collaboratorinviterequests._id,
                    team: this.$route.params.tid
                }
                let response = await cancelCollaboratorInvitation(body)
                // success message
                message(this, constants.messageType.SUCCESS, response.message)
                // update list
                this.fetchPeopleList()
                // update counts
                this.getInviteCounts()
            } catch (error) {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            }
            loader(this, false)
        },
        
        /**
         * cancel the pending request
         */
        async cancelPeopleInvitation (invite) {
            try {
                loader(this, true)
                // body for api
                let body = {
                    invite_id: invite.teaminviterequests._id,
                    team: this.$route.params.tid
                }
                // api call
                let response = await cancelTeamMemberInvitation(body)
                // success message
                message(this, constants.messageType.SUCCESS, response.message)
                // update list
                this.fetchPeopleList()
                // update counts
                this.getInviteCounts()
            } catch (error) {
                // error message
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this), routeErrorHandler.bind(this, {name: pageRoute.organisationTeams, params: {id: this.$route.params.id}})))
                // error handler for permissions
                this.rolesErrorHandler(error, true)
            }
            loader(this, false)
        },

        /**
         * refresh logs if a member is invited
         */
        refreshLogs () {
            // to update counts
            this.getInviteCounts()
            if (this.selectedMenu === constants.PEOPLE_LIST.PENDING_INVITATION) this.fetchPeopleList()
        },
    }
}